import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "13 9.5 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M19 9.5L13 15.5", stroke: "#F31260", strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ e.createElement("path", { d: "M13 9.5L19 15.5", stroke: "#F31260", strokeLinecap: "round", strokeLinejoin: "round" }));
export {
  o as default
};
